/**
 * Convert number to number with commas
 * @param  {Number} x number to convert
 * @return {String}   number with commas
 */
export default function numberWithCommas (n) {
  if (!n) return null

  let parts = n.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}


// WEBPACK FOOTER //
// ./modules/utils/numberWithCommas.js